<template>

<div class="toggle" @click="toggle()">
    <div class="option" :class="{'active': value}">Médicos</div>
    <div class="option" :class="{'active': !value}">Exámenes</div>
    <div class="bg-bar" :class="{'active': value}"></div>
</div>
        
</template>

<script>
export default {
    name: "MedicClinicToggle",
    props: ['value'],
	data(){
		return{
            searchMedics: true
		}
    },
    methods: {
        toggle(){
            this.value =! this.value
            this.$emit('input', this.value)
        }
    }
}
</script>

<style scoped>
.toggle{
    display:flex;
    align-items:center;
    border-radius:14px;
    background-color: #f3f3f3;
    height:40px;
    width: 240px;
    margin: auto;
    position: relative;
    border-radius: 28px;
    cursor:pointer;
}
.toggle .option{
    font-size: 14px;
    flex-grow: 1;
    height:32px;
    text-align: center;
    width: 120px;
    display:flex;
    align-items:center;
    justify-content: center;
    z-index: 2;
    transition: all 0.2s ease-in-out;
}

.toggle .option.active{
    color: #FFF;
}
.toggle .bg-bar{
    transition: all 0.2s ease-in-out;
    position:absolute;
    background-color:#12bece;
    width: 120px;
    top:4px;
    left:4px;
    height:32px;
    border-radius: 28px;
    z-index: 1;
}

.toggle .bg-bar:not(.active){
    left: calc(50% - 4px);
}

</style>
